import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getDocumentByType, getSubject, getInputs, getRejectedReason, loadDocumentsValidate, getStatusValidation, getListAdditionalDocument, registerAdditionalDocument, updateAdditionalDocument, verificateData, getDataValidation, getConfigurationData, getStatusVerification, getCertificateType, getSetpsVerification, getDocumentList } from './documentaryValidationAPI';

const initialState = {
  statusDocument: "idle",
  documentByType: "",

  statusSubject: "idle",
  subject: "",

  statusInputs: "idle",
  inputs: "",

  statusReasons: "idle",
  rejectedReasons: "",

  statusValidate: "idle",
  validateData: "",

  statusActualValidate: "idle",
  actualValidate: "",

  statusListAdditional: "idle",
  listAdditional: [],

  statusRegisterAdditionalDocument: "idle",
  registerAdditionalDocument: "",

  statusUpdateAdditionalDocument: "idle",
  updateAdditionalDocument: "",

  statusVerificateData: "idle",
  verificateData: [],

  statusDataVerification : "idle",
  dataInitial: [],

  statusDataConfiguration : "idle",
  dataConfiguration : [],

  statusCertificateStatus : "idle",
  dataStatusCertificate : [],
  
  statusCertificateType : "idle",
  dataCertificateType : [],

  statusStepVerification : "idle",
  dataStepsVerification: [],

  statusDocumentList : "idle",
  documentList : []
};

export const configurationData = createAsyncThunk(
  '/documentaryValidation/getConfigurationData',
  async (data) => {
    const response = await getConfigurationData(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const createDocumentList = createAsyncThunk(
  '/documentaryValidation/createDocumentList',
  async (data) => {
    const response = await getDocumentList(data);
    return response;
  }
);

export const certificateStatus = createAsyncThunk(
  '/documentaryValidation/certificateStatus',
  async () => {
    const response = await getStatusVerification();
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const certificateTypes = createAsyncThunk(
  '/documentaryValidation/certificateTypes',
  async () => {
    const response = await getCertificateType();
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);
export const dataVerification = createAsyncThunk(
  '/documentaryValidation/dataVerification',
  async (data) => {
    const response = await getDataValidation(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const steptsVerification = createAsyncThunk(
  '/documentaryValidation/getSetpsVerification',
  async (data) => {
    const response = await getSetpsVerification(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);
export const updateAddDocument = createAsyncThunk(
  '/documentaryValidation/updateAdditionalDocument',
  async (data) => {
    const response = await updateAdditionalDocument(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const verificateDataConsult = createAsyncThunk(
  '/documentaryValidation/verificateDataConsult',
  async (data) => {
    const response = await verificateData(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);
export const registerAddDocument = createAsyncThunk(
  '/documentaryValidation/registerAddDocument',
  async (data) => {
    const response = await registerAdditionalDocument(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getAdditionalList = createAsyncThunk(
  '/documentaryValidation/getAdditionalList',
  async (data) => {
    const response = await getListAdditionalDocument(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getActualValidate = createAsyncThunk(
  '/documentaryValidation/getActualValidate',
  async (data) => {
    const response = await getStatusValidation(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getDocument = createAsyncThunk(
  '/documentaryValidation/getDocument',
  async (data) => {
    const response = await getDocumentByType(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const validateDocument = createAsyncThunk(
  '/documentaryValidation/validateDocument',
  async (data) => {
    const response = await loadDocumentsValidate(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getReasons = createAsyncThunk(
  '/documentaryValidation/getReasons',
  async (data) => {
    const response = await getRejectedReason();
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getSubjectValidation = createAsyncThunk(
  '/documentaryValidation/getSubject',
  async (data) => {
    const response = await getSubject(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);

export const getInputsValidation = createAsyncThunk(
  '/documentaryValidation/getInputs',
  async (data) => {
    const response = await getInputs(data);
    if (response.status === 'error') throw ({ message: response.data.message })
    return response.data;
  }
);



export const documentaryValidationSlice = createSlice({
  name: 'documentaryValidation',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocument.pending, (state) => {
        state.statusDocument = 'loading';
      })
      .addCase(getDocument.fulfilled, (state, action) => {
        state.statusDocument = 'fulfilled';
        state.documentByType = action.payload;
      })
      .addCase(getDocument.rejected, (state) => {
        state.statusDocument = 'rejected';
      })
      .addCase(getSubjectValidation.pending, (state) => {
        state.statusSubject = 'loading';
      })
      .addCase(getSubjectValidation.fulfilled, (state, action) => {
        state.statusSubject = 'fulfilled';
        state.subject = action.payload;
      })
      .addCase(getSubjectValidation.rejected, (state) => {
        state.statusSubject = 'rejected';
      })
      .addCase(getInputsValidation.pending, (state) => {
        state.statusInputs = 'loading';
      })
      .addCase(getInputsValidation.fulfilled, (state, action) => {
        state.statusInputs = 'fulfilled';
        state.inputs = action.payload;
      })
      .addCase(getInputsValidation.rejected, (state) => {
        state.statusInputs = 'rejected';
      })
      .addCase(getReasons.pending, (state) => {
        state.statusReasons = 'loading';
      })
      .addCase(getReasons.fulfilled, (state, action) => {
        state.statusReasons = 'fulfilled';
        state.rejectedReasons = action.payload;
      })
      .addCase(getReasons.rejected, (state) => {
        state.statusReasons = 'rejected';
      })

      .addCase(validateDocument.pending, (state) => {
        state.statusValidate = 'loading';
      })
      .addCase(validateDocument.fulfilled, (state, action) => {
        state.statusValidate = 'fulfilled';
        state.validateData = action.payload;
      })
      .addCase(validateDocument.rejected, (state) => {
        state.statusValidate = 'rejected';
      })

      .addCase(getActualValidate.pending, (state) => {
        state.statusActualValidate = 'loading';
      })
      .addCase(getActualValidate.fulfilled, (state, action) => {
        state.statusActualValidate = 'fulfilled';
        state.actualValidate = action.payload;
      })
      .addCase(getActualValidate.rejected, (state) => {
        state.statusActualValidate = 'rejected';
      })

      .addCase(getAdditionalList.pending, (state) => {
        state.statusListAdditional = 'loading';
      })
      .addCase(getAdditionalList.fulfilled, (state, action) => {
        state.statusListAdditional = 'fulfilled';
        state.listAdditional = action.payload;
      })
      .addCase(getAdditionalList.rejected, (state) => {
        state.statusListAdditional = 'rejected';
      })

      .addCase(registerAddDocument.pending, (state) => {
        state.statusRegisterAdditionalDocument = 'loading';
        state.statusListAdditional = 'loading';
      })
      .addCase(registerAddDocument.fulfilled, (state, action) => {
        state.statusRegisterAdditionalDocument = 'fulfilled';
        state.registerAdditionalDocument = action.payload;
      })
      .addCase(registerAddDocument.rejected, (state) => {
        state.statusRegisterAdditionalDocument = 'rejected';
      })

      .addCase(updateAddDocument.pending, (state) => {
        state.statusUpdateAdditionalDocument = 'loading';
        state.statusListAdditional = 'loading';
      })
      .addCase(updateAddDocument.fulfilled, (state, action) => {
        state.statusUpdateAdditionalDocument = 'fulfilled';
        state.updateAdditionalDocument = action.payload;
      })
      .addCase(updateAddDocument.rejected, (state) => {
        state.statusUpdateAdditionalDocument = 'rejected';
      })

      .addCase(verificateDataConsult.pending, (state) => {
        state.statusVerificateData = 'loading';
      })
      .addCase(verificateDataConsult.fulfilled, (state, action) => {
        state.statusVerificateData = 'fulfilled';
        state.verificateData = action.payload;
      })
      .addCase(verificateDataConsult.rejected, (state) => {
        state.statusVerificateData = 'rejected';
      })

      .addCase(dataVerification.pending, (state) => {
        state.statusDataVerification = 'loading';
      })
      .addCase(dataVerification.fulfilled, (state, action) => {
        state.statusDataVerification = 'fulfilled';
        state.dataInitial = action.payload;
      })
      .addCase(dataVerification.rejected, (state) => {
        state.statusDataVerification = 'rejected';
      })
      
      .addCase(configurationData.pending, (state) => {
        state.statusDataConfiguration = 'loading';
      })
      .addCase(configurationData.fulfilled, (state, action) => {
        state.statusDataConfiguration = 'fulfilled';
        state.dataConfiguration = action.payload;
      })
      .addCase(configurationData.rejected, (state) => {
        state.statusDataConfiguration = 'rejected';
      })

      .addCase(certificateStatus.pending, (state) => {
        state.statusCertificateStatus = 'loading';
      })
      .addCase(certificateStatus.fulfilled, (state, action) => {
        state.statusCertificateStatus = 'fulfilled';
        state.dataStatusCertificate = action.payload;
      })
      .addCase(certificateStatus.rejected, (state) => {
        state.statusCertificateStatus = 'rejected';
      })

      .addCase(certificateTypes.pending, (state) => {
        state.statusCertificateType = 'loading';
      })
      .addCase(certificateTypes.fulfilled, (state, action) => {
        state.statusCertificateType = 'fulfilled';
        state.dataCertificateType = action.payload;
      })
      .addCase(certificateTypes.rejected, (state) => {
        state.statusCertificateType = 'rejected';
      })

      .addCase(steptsVerification.pending, (state) => {
        state.statusStepVerification = 'loading';
      })
      .addCase(steptsVerification.fulfilled, (state, action) => {
        state.statusStepVerification = 'fulfilled';
        state.dataStepsVerification = action.payload;
      })
      .addCase(steptsVerification.rejected, (state) => {
        state.statusStepVerification = 'rejected';
      })

      .addCase(createDocumentList.pending, (state) => {
        state.statusDocumentList = 'loading';
      })
      .addCase(createDocumentList.fulfilled, (state, action) => {
        state.statusDocumentList = 'fulfilled';
        state.documentList = action.payload;
      })
      .addCase(createDocumentList.rejected, (state) => {
        state.statusDocumentList = 'rejected';
      })
  },
});

export const { reset } = documentaryValidationSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStatusDataConfiguration = (state) => state.documentaryValidation.statusDataConfiguration;
export const selectDataConfiguration = (state) => state.documentaryValidation.dataConfiguration;

export const selectStatusDataVerificationt = (state) => state.documentaryValidation.statusDataVerification;
export const selectDataInitial = (state) => state.documentaryValidation.dataInitial;

export const selectStatusDocument = (state) => state.documentaryValidation.statusDocument;
export const selectDocumentByType = (state) => state.documentaryValidation.documentByType;

export const selectStatusSubject = (state) => state.documentaryValidation.statusSubject;
export const selectSubject = (state) => state.documentaryValidation.subject;

export const selectStatusInputs = (state) => state.documentaryValidation.statusInputs;
export const selectInputs = (state) => state.documentaryValidation.inputs;

export const selectStatusReason = (state) => state.documentaryValidation.statusReasons;
export const selectReasons = (state) => state.documentaryValidation.rejectedReasons;

export const selectStatusValidate = (state) => state.documentaryValidation.statusValidate;
export const selectValidateData = (state) => state.documentaryValidation.validateData;

export const selectStatusActualValidate = (state) => state.documentaryValidation.statusActualValidate;
export const selectActualValidate = (state) => state.documentaryValidation.actualValidate;

export const selectStatusListAdditional = (state) => state.documentaryValidation.statusListAdditional;
export const selectListAdditional = (state) => state.documentaryValidation.listAdditional;

export const selectStatusRegisterAdditional = (state) => state.documentaryValidation.statusRegisterAdditionalDocument;
export const selectRegisterAdditional = (state) => state.documentaryValidation.registerAdditionalDocument;

export const selectStatusUpdateAdditional = (state) => state.documentaryValidation.statusUpdateAdditionalDocument;
export const selectUpdateAdditional = (state) => state.documentaryValidation.updateAddDocument;

export const selectStatusVerificateData = (state) => state.documentaryValidation.statusVerificateData;
export const selectVerificateData = (state) => state.documentaryValidation.verificateData;

export const selectStatusCertificateStatus = (state) => state.documentaryValidation.statusCertificateStatus;
export const selectDataStatusCertificate = (state) => state.documentaryValidation.dataStatusCertificate;

export const selectStatusCertificateType = (state) => state.documentaryValidation.statusCertificateType;
export const selectDataCertificateType = (state) => state.documentaryValidation.dataCertificateType; 

export const selectStatusStepsVerification = (state) => state.documentaryValidation.statusStepVerification;
export const selectDataStepsVerification = (state) => state.documentaryValidation.dataStepsVerification;

export const selectStatusDocumentList = (state) => state.documentaryValidation.statusDocumentList;
export const selectDocumentList = (state) => state.documentaryValidation.documentList;
export default documentaryValidationSlice.reducer;
